module.exports = __webpack_public_path__ + "media/eternal_anamnesis.a121615a.mp3";